import React from "react";

import Button from "react-bootstrap/Button";

import { InfoIcon } from "../InfoIcon";

// flex packs item -> venue page
// event banner
export default function DetailsButton({ onClick, size = "sm" }) {
  return (
    <Button
      variant="default"
      aria-label="Information"
      onClick={onClick}
      className={`border-0 btn--icon btn--icon-${size}`}
    >
      <InfoIcon />
    </Button>
  );
}
